import React from 'react';

import StatusSummaryButton from '../../../status/statusSummaryButton.jsx';
import partnerPropTypes from '../../../partnerPropTypes.js';
import { data as paymentDataPropTypes } from '../../../paymentPropTypes.js';
import withdrawalPropTypes from '../../../withdrawalPropTypes.js';

function getStatusSummary({ partner, payment }) {
    return payment.performedBy === 'BACKOFFICE'
        ? `Vi har hevet kjøpet på vegne av ${partner.name}.`
        : `${partner.name} har hevet kjøpet.`;
}
const PaymentRevertedSummary = ({ partner, payment, withdrawal }) => {
    let actionRequiredType;
    let body;

    if (withdrawal) {
        body = 'Du har fått tilbake pengene';
    } else {
        actionRequiredType = 'NEGATIVE';
        body = 'Få tilbake pengene';
    }

    return (
        <StatusSummaryButton
            href="/handel-hevet"
            statusSummary={getStatusSummary({ partner, payment })}
            actionRequiredType={actionRequiredType}
        >
            {body}
        </StatusSummaryButton>
    );
};

PaymentRevertedSummary.propTypes = {
    partner: partnerPropTypes.isRequired,
    payment: paymentDataPropTypes.isRequired,
    withdrawal: withdrawalPropTypes,
};

export default PaymentRevertedSummary;



// WEBPACK FOOTER //
// ./safeTrade/buyer/payment/summaries/paymentRevertedSummary.jsx